import { compose as o } from "../../../tailwind-buddy-interface.js";
const t = o({
  slots: {
    root: "break-words"
  },
  variants: {},
  compoundVariants: [
    // isDisabled="false"
    {
      conditions: {
        isDisabled: !1
      },
      class: {
        root: "text-color-secondary"
      }
    },
    // isDisabled="true"
    {
      conditions: {
        isDisabled: !0
      },
      class: {
        root: "text-color-scheme-interactive-disabled-400"
      }
    }
  ],
  defaultVariants: {},
  responsiveVariants: []
})();
export {
  t as fieldHelperTextVariants
};
